import React, { useContext } from 'react'
import { RoomTypes } from '@weblite/ts-action/room'
import { SearchedPvListItemWithStatus } from '$common/room-list-search/searched-user-list-item-with-status'
import { SearchedHallListItemWithStatus } from '$common/room-list-search/searched-hall-list-item-with-status'
import { SearchedWappRoomListItemWithStatus } from '$common/room-list-search/searched-wapp-room-list-item-with-status'
import { SearchedPrivateSpaceListItemWithStatus } from '$common/room-list-search/searched-private-space-list-item-with-status'
import { useRoom } from '$logic/room/react-hook'
import { nothing } from '$func/utils'
import { ForwardSearchQueryContext } from '$comp/_app/components/leftPanel/components/forward-list'

interface Props {
  roomId: string
  onClick?: (roomId: string, selected: boolean) => any
  onContextMenu?: (e: Event, roomId: string) => any
  selectionMap: Record<string, boolean>
}

const componentMapper: Record<RoomTypes, any> = {
  CHANNEL: SearchedHallListItemWithStatus,
  GROUP: SearchedHallListItemWithStatus,
  PV: SearchedPvListItemWithStatus,
  WAPP_ROOM: SearchedWappRoomListItemWithStatus,
  PRIVATE_SPACE: SearchedPrivateSpaceListItemWithStatus,
}

export function SearchedRoomListItemWithStatus({
  roomId,
  onClick: clickHandler = nothing,
  onContextMenu = nothing,
  selectionMap,
}: Props) {
  const room = useRoom(roomId)

  const selected = selectionMap[roomId]

  const onClick = () => clickHandler(roomId, selected)
  const searchQuery = useContext(ForwardSearchQueryContext)
  if (!room) return null

  const Component = componentMapper[room?.type]

  return (
    <Component
      roomId={roomId}
      onClick={onClick}
      onContextMenu={(e: Event) => onContextMenu(e, roomId)}
      selected={selected}
      searchQuery={searchQuery}
    />
  )
}
